(() => {
    class CampaignsService {
        constructor(
            APIService,
            PermissionService,
            $q,
            $rootScope,
            $uibModal
        ) {
            this.APIService = APIService;
            this.PermissionService = PermissionService;
            this.$q = $q;
            this.$rootScope = $rootScope;
            this.$uibModal = $uibModal;
        }
        /**
         * Gets the number of customers for a specific campaign and store id
         * @param campaign {string}
         * @param storeId {number}
         * @returns {promise}
         */
        getNumberOfCustomersForCampaign(campaign, storeId) {
            return this.APIService.Campaigns.getNumberOfCustomersForCampaign(
                campaign, storeId
            );
        }

        /**
         * Creates the campaign
         * @param campaign
         * @returns {*|HTTPPromise}
         */
        createCampaign(campaign) {
            return this.APIService.Campaigns.createCampaign(campaign);
        }

        /**
         * Returns a published campaign template by campaign id
         * @param campaignTemplateId {number}
         * @param storeId {number}
         * @param brandId {number}
         */
        getCampaignTemplate(campaignTemplateId, storeId, brandId) {
            return this.APIService.Campaigns.getCampaignTemplate(
                campaignTemplateId,
                storeId,
                brandId
            );
        }

        /**
         * Gets a collection of valid end dates for a campaign template based on the start date passed in
         * @param campaignTemplateId {number}
         * @param storeId {number}
         * @param brandId {number}
         * @param startDate {Date}
         */
        getCampaignTemplateValidEndDates(campaignTemplateId, storeId, brandId, startDate) {
            return this.APIService.Campaigns.getCampaignTemplateValidEndDates(
                campaignTemplateId,
                storeId,
                brandId,
                startDate
            );
        }

        /**
         * Returns the current published campaigns for the store or brand context
         * @param storeId {number}
         * @param brandId
         * @returns {Promise}
         */
        getPublishedCampaigns(storeId, brandId) {
            return this.APIService.Campaigns.getPublishedCampaigns(
                storeId,
                brandId
            );
        }

        getFavouriteCampaigns(storeId, brandId) {
            return this.APIService.Campaigns.getFavouriteCampaigns(
                storeId,
                brandId
            );        };

        getCampaignStatusCount(storeId, brandId) {
            return this.APIService.Campaigns.getCampaignStatusCount(
                storeId,
                brandId
            );
        }

        /**
         * Publishes the campaign
         * @param campaign {PublishCampaignRequest}
         */
        publishCampaign(campaign) {
            const req = { ...campaign };
            if (req.StoreId === 0) {
                req.StoreId = undefined
            }
            return this.APIService.Campaigns.publishCampaign(
                req
            ).then(result => {
                this.$rootScope.$broadcast(window.Dashboard.Events.CampaignUpdated);
                return result;
            });
        }

        cancelCampaign(campaignId) {
            return this.APIService.Campaigns.cancelCampaign(
                campaignId
            ).then(result => {
                this.$rootScope.$broadcast(window.Dashboard.Events.CampaignUpdated);
                return result;
            });
        };

        /**
         * Returns the current active campaigns for the store or brand context
         * @param storeId {number}
         * @param brandId {number}
         * @returns {Promise}
         */
        getActiveCampaigns(storeId, brandId) {
            return this.APIService.Campaigns.getActiveCampaigns(
                storeId,
                brandId
            );
        }

        getScheduledCampaigns(storeId, brandId) {
            return this.APIService.Campaigns.getScheduledCampaigns(
                storeId,
                brandId
            );
        }

        getCancelledCampaigns(storeId, brandId, page, count, query) {
            return this.APIService.Campaigns.getCancelledCampaigns(
                storeId,
                brandId,
                page,
                count,
                query
            );
        }

        getCompletedCampaigns(
            storeId,
            brandId,
            page,
            count,
            query
        ) {
            return this.APIService.Campaigns.getCompletedCampaigns(
                storeId,
                brandId,
                page,
                count,
                query
            );
        }

        /**
         * Shows the terms and conditions modal
         */
        showTermsAndConditionsModal() {
            // Show the terms and conditions modal
            this.$uibModal.open({
                animation: true,
                templateUrl: 'components/campaigns/termsandconditions/termsandconditions.f68836e8.html',
                controller: 'TermsAndConditionsModalController',
                size: 'lg',
                backdrop: 'static'
            });
        }

        GetCustomerEstimatesFromCampaignTargetSourceId(
            campaignTargetSourceId,
            campaignTemplateGuid,
            brandId,
            storeId
        ) {
            return this.APIService.Campaigns.getCustomerEstimatesFromCampaignTargetSourceId(
                campaignTargetSourceId,
                campaignTemplateGuid,
                brandId,
                storeId
            );
        }
    }

    angular.module('dashboard')
        .service('CampaignsService', [
            'APIService',
            'PermissionService',
            '$q',
            '$rootScope',
            '$uibModal',
            CampaignsService
        ]);
})();
